import { render, staticRenderFns } from "./member_fans.vue?vue&type=template&id=18766c39&scoped=true&"
import script from "./member_fans.vue?vue&type=script&lang=js&"
export * from "./member_fans.vue?vue&type=script&lang=js&"
import style0 from "./member_fans.vue?vue&type=style&index=0&id=18766c39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18766c39",
  null
  
)

export default component.exports